import React from "react";
import { toast } from "react-toastify";
import { resendBookingID } from "../../utils/requestHandler";

const ResendBookingForm = ({ setShowResendBookingPopup }) => {
  const [lastName, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");

  const handleSubmit = () => {
    if (!lastName || !email) {
      toast.error("Please fill in all fields");
      return;
    }
    resendBookingID(email, lastName).then((res) => {
      if (res.status === "success") {
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    });
    setShowResendBookingPopup(false);
  };
  return (
    <div className="flex bg-mv-backdrop bg-opacity-80 fixed left-0 right-0 bottom-0 top-0 items-center justify-center min-h-screen">
      <div className="w-full relative max-w-lg p-8 space-y-6 bg-white rounded-lg shadow-lg">
        <div className="flex absolute right-2 top-2 justify-end">
          <close
            onClick={() => setShowResendBookingPopup(false)}
            className="cursor-pointer text-4xl"
          >
            &times;
          </close>
        </div>
        <h2 className="text-2xl font-bold !m-0 uppercase text-mv-darkblue text-nowrap text-center">
          Enter Reservation Information
        </h2>
        <form className="space-y-4">
          <div>
            <label
              htmlFor="lastName"
              className="block uppercase text-sm font-medium text-gray-700"
            >
              Last Name of Primary Guest
            </label>
            <input
              id="lastName"
              name="lastName"
              onChange={(e) => setLastName(e.target.value)}
              type="text"
              required
              className="block w-full px-3 py-2 border rounded mt-1 border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="Last Name of Primary Guest"
            />
          </div>
          <div>
            <label
              htmlFor="email"
              className="block uppercase text-sm font-medium text-gray-700"
            >
              Email Address of Primary Guest
            </label>
            <input
              id="email"
              name="email"
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required
              className="block w-full mt-1 px-3 py-2 border rounded border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="Email Address of Primary Guest"
            />
          </div>
          <div>
            <span className="block text-sm font-medium text-gray-700">
              Do you have multiple sailing dates with Margaritaville at Sea?
            </span>
            <div className="mt-2 space-y-2">
              <div className="flex items-center">
                <input
                  id="yes"
                  name="multipleDates"
                  type="radio"
                  className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                />
                <label
                  htmlFor="yes"
                  className="ml-3 block text-sm font-medium text-gray-700"
                >
                  Yes
                </label>
              </div>
              <div className="flex items-center">
                <input
                  id="no"
                  name="multipleDates"
                  type="radio"
                  className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                />
                <label
                  htmlFor="no"
                  className="ml-3 block text-sm font-medium text-gray-700"
                >
                  No
                </label>
              </div>
            </div>
          </div>
          <div>
            <button
              type="submit"
              onClick={() => handleSubmit()}
              className="w-full uppercase px-4 py-2 text-white font-semibold bg-mv-darkblue border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Resend Booking Number
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResendBookingForm;
